import * as THREE from 'three';
import { AssetLoader } from '../loading/AssetLoader';
import { CityBuilder } from './CityBuilder';
import { ForestGenerator } from './ForestGenerator';
import { CarTraffic } from './CarTraffic';
import { EnvironmentSetup } from './EnvironmentSetup';
import { CollisionWorld } from '../collision/CollisionWorld';

export class WorldManager {
  environment: EnvironmentSetup;
  cityBuilder: CityBuilder;
  forest: ForestGenerator;
  traffic: CarTraffic;
  collisionWorld: CollisionWorld;

  constructor(scene: THREE.Scene, loader: AssetLoader) {
    this.collisionWorld = new CollisionWorld();

    // Environment (sky, lights, fog, ground)
    this.environment = new EnvironmentSetup(scene);

    // City builder
    this.cityBuilder = new CityBuilder(scene, loader, this.collisionWorld);

    // Forest
    this.forest = new ForestGenerator(scene, loader);

    // Traffic
    this.traffic = new CarTraffic(scene, loader);
  }

  buildRoads() {
    this.cityBuilder.buildRoads();
    this.collisionWorld.addCityBounds();
  }

  async buildBuildings() {
    await this.cityBuilder.buildBuildings();
  }

  buildDetails() {
    this.cityBuilder.buildDetails();
  }

  spawnTraffic() {
    this.traffic.spawn();
  }

  buildForest() {
    this.forest.generate();
  }

  update(delta: number, playerX: number, playerZ: number) {
    // Move shadow light to follow player
    this.environment.updateShadowTarget(playerX, playerZ);
    // Animate cars
    this.traffic.update(delta);
  }
}
